export default "__VITE_ASSET__hxIdvfEh$$_uTfLd__KJww__"